import type { Router } from 'vue-router'
import interceptor from '@/config/interceptor'

export const getInterceptorRouter = (router: Router) => interceptor.getInterceptorRouter(router)